import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Row } from 'antd';

import userImgDefault from '../../assets/user.png';
import api from '../../services/api';
import { logout, getIdKey } from '../../services/auth';
import { Header, Thumbnail, ThumbnailContainer } from './styles';

export default function HeaderComponent({
  title,
  subTitle,
  content,
  onBack,
}) {
  const [user, setUser] = useState({});
  const history = useHistory();

  useEffect(() => {
    const id = getIdKey();
    const loadUser = async () => {
      const res = await api.get(`/adm/${id}`);
      if (res.data) {
        setUser(res.data);
        return;
      }

      logout();
      history.push('/');
    };

    loadUser();
  }, [history]);

  return (
    <Header
      ghost={false}
      title={title}
      subTitle={subTitle}
      onBack={onBack}
    >
      <Row>
        <div style={{ flex: 1 }}>{content}</div>
        <ThumbnailContainer>
          <Thumbnail
            src={user.thumbnail ? user.thumbnail_url : userImgDefault}
          />
          <strong>{user.name}</strong>
        </ThumbnailContainer>
      </Row>
    </Header>
  );
}
